import { Pipe, PipeTransform } from '@angular/core';
import { ModuleNameService } from 'src/app/services/module-name.service';

@Pipe({
  name: 'moduleName',
   pure: false // important!
})
export class ModuleNamePipe implements PipeTransform {

   modules: any;

  constructor(
    private moduleNameService: ModuleNameService,
  ) {
    this.getModuleList();
  }

  getModuleList() {

    this.moduleNameService.getAllModuleNameDropDown().subscribe(
      res => {
        this.modules = res;

      },
      error => {
      })
  }

 transform(routerPath: string): string {
    if (!routerPath || this.modules?.length === 0) {
      return '';
    }
    const match = this.modules?.find(
      m => m.router.toLowerCase() === routerPath.toLowerCase()
    );
    
    return match ? match.displayName : '';
  }

}
